// extracted by mini-css-extract-plugin
export default {"regularPage":"regularPage_regularPage__cF0ZH"};